import merchantsApiFactory from '../../modules/merchants/merchantsApi';

/* Actions */
import {
  getMerchantsActionCreators,
} from '../actions/merchantsActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function merchantsSagasFactory({storefrontApiClient}) {
  const merchantsApi = merchantsApiFactory(storefrontApiClient);
  const getMerchantsSagas = generateDefaultAsyncSaga(
    merchantsApi.getMerchants,
    getMerchantsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetMerchantss = generateDefaultAsyncWatcher(
    'GET_MERCHANTS',
    getMerchantsSagas
  );

  const merchantsSagas = [
    watchGetMerchantss(),
  ];

  return merchantsSagas;
}

export default merchantsSagasFactory; 